/* Copyright 2013 - 2024 Waiterio LLC */
import Restaurant from '@waiterio/model/Restaurant.js'
import get from '@waiterio/api-client/get.js'

export default function getRestaurant(restaurantId) {
  return get({ url: `restaurants/${restaurantId}` }).then(
    restaurant => new Restaurant(restaurant),
  )
}
